import { Table, Tag } from "antd";
import dayjs from "dayjs";
import { Order } from "../../entities/interfaces/order";
import { useNavigate } from "react-router";

type Props = {
  orders: Order[];
  onSelect: (service: Order) => void;
};

const OrderList = ({ orders, onSelect }: Props) => {
  const navigate = useNavigate();
  const columns = [
    {
      title: "Order Id",
      dataIndex: "orderId",
      key: "orderId",
    },
    {
      title: "Customer",
      key: "customer",
      render: (record: Order) => <p>{record.customer.name}</p>,
    },
    {
      title: "Date",
      key: "date",
      render: (record: Order) => (
        <p className="capitalize">
          {dayjs(record.date).format("DD/MM/YYYY HH:mm:A")}
        </p>
      ),
    },
    {
      title: "Status",
      key: "status",
      render: (record: Order) => {
        return record.paid ? (
          <Tag color="green">PAID</Tag>
        ) : (
          <Tag color="red">PENDING</Tag>
        );
      },
    },
    {
      title: "Amount",
      key: "amount",
      render: (record: Order) => {
        return record.bill ? (
          <p>₹ {record.bill?.totalAmount}</p>
        ) : (
          "Bill not generated"
        );
      },
    },
  ];

  return (
    <Table
      dataSource={orders}
      columns={columns}
      rowClassName="hover:cursor-pointer"
      pagination={false}
      onRow={(record) => {
        return {
          onClick: () => {
            navigate(`/orders/${record.id}`);
          },
        };
      }}
    />
  );
};

export default OrderList;
